<template>
  <Wrapper
    id="social-accounts-edit"
    :header="$t('_web_profile-edit_linked-accounts', 'Socials')"
    :join="join"
  >
    <SocialsGroup v-model="accountSocials" v-bind="{ columns, items }" />
    <div v-if="account && account.isOrganization" class="mt-4">
      {{
        $t(
          '_web_profile-edit_social-accounts-info',
          'To automatically share posts to your Social media, please'
        )
      }}&nbsp;
      <a href="#" @click.prevent.stop="openSocialIntegrationModal">{{
        $t('_web_profile-edit_social-accounts-link', 'Link social accounts')
      }}</a>
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import Wrapper from '../../PanelWrapper';
import SocialsGroup from '@/components/form/SocialsGroup';
import { prop } from '@/utils/factories';

export default {
  name: 'AccountEditSocials',
  components: {
    SocialsGroup,
    Wrapper,
  },
  props: {
    join: prop(String),
    columns: prop(Number, 1),
  },
  data() {
    return {
      items: [
        { id: 'fb', title: 'Facebook' },
        { id: 'instagram', title: 'Instagram' },
        { id: 'twitter', title: 'Twitter' },
        { id: 'discord', title: 'Discord' },
      ],
    };
  },
  computed: {
    ...mapGetters(['accountEditData']),
    ...mapState('my', ['account']),
    accountSocials: {
      get() {
        return this.accountEditData.social || {};
      },
      set(social) {
        this.updateEditData({ social });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
    ...mapActions(['openModal']),
    openSocialIntegrationModal() {
      this.openModal({
        name: 'SocialIntegrationModal',
        settings: {
          containerClass: 'p-0 overflow-hidden',
          variant: 'fit-content',
          closeIcon: true,
          clickOnBackdrop: true,
        },
      });
    },
  },
};
</script>
